"use strict";

module.exports = require('./src/poisson-disk-sampling');
